import i18n from '../../locales/index'
/* eslint-disable */
import { genBasicStore } from '../vuex';
import assign from 'lodash/assign';
import axios from 'axios';
import { Message } from 'view-design'

const store = genBasicStore('score_reward');

assign(store.actions, {
	async run ({ commit }, params) {
		await axios.post(`score_rewards/${params.id}/run`)
		Message.success(i18n.t('store_modules_schedule_display_product_1339'))
	  },
	})

export default store;